"use strict";

module.exports = function () {
    var $infoIcon = $(".info-icon");

    $infoIcon.on("mouseenter focusin", function () {
        $(this).find(".tooltip").removeClass("d-none");
    });

    $infoIcon.on("mouseleave focusout", function () {
        $(this).find(".tooltip").addClass("d-none");
    });
};
